"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _cssConstants = _interopRequireDefault(require("../../../../../../targets/cord_eurofh_teams/cssConstants.js"));

var _StoreComponent2 = _interopRequireDefault(require("../store/StoreComponent"));

var _Validations = require("../../validations/Validations");

var _GenericStore = require("../store/GenericStore");

var _reactI18next = require("react-i18next");

var _styles = require("@material-ui/core/styles");

var _ERGOComponents = _interopRequireDefault(require("../../../DrupalTiles/ERGO/ERGOComponents.scss"));

var _Image = _interopRequireDefault(require("../../../Image/Image"));

var _ErgoCandidateView = require("../../../DrupalTiles/ERGO/ErgoCandidateView");

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _QuizStrings = require("../../../Equizzer/QuizStrings");

var _CordovaHelper = require("../../../../../helpers/CordovaHelper");

var _MuiAlertHelper = require("../../../../../helpers/MuiAlertHelper");

var _targetCss$colors, _targetCss$colors2, _targetCss$colors3, _targetCss$colors4;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var StyledButton = (0, _styles.withStyles)({
  root: {
    padding: '15px !important',
    display: 'inline-block !important',
    verticalAlign: 'top !important',
    backgroundColor: (_targetCss$colors = _cssConstants["default"].colors) === null || _targetCss$colors === void 0 ? void 0 : _targetCss$colors.buttonBackground,
    color: (_targetCss$colors2 = _cssConstants["default"].colors) === null || _targetCss$colors2 === void 0 ? void 0 : _targetCss$colors2.buttonCaption,
    '&:hover': {
      backgroundColor: (_targetCss$colors3 = _cssConstants["default"].colors) === null || _targetCss$colors3 === void 0 ? void 0 : _targetCss$colors3.buttonBackgroundHover,
      color: (_targetCss$colors4 = _cssConstants["default"].colors) === null || _targetCss$colors4 === void 0 ? void 0 : _targetCss$colors4.buttonCaption
    }
  }
})(_Button["default"]);
var style = {
  picPreviewContainer: {
    height: '44px',
    width: '44px',
    borderRadius: '50%',
    display: 'inline-block',
    overflow: 'hidden',
    marginRight: '20px'
  },
  picPreview: {
    margin: '10px 0'
  },
  previewPic: {
    width: '100%',
    height: '100%'
  }
};

var FormImage = /*#__PURE__*/function (_StoreComponent) {
  (0, _inherits2["default"])(FormImage, _StoreComponent);

  var _super = _createSuper(FormImage);

  function FormImage(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, FormImage);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "changeProfilePic", function () {
      var parentPath = _this.props.parentPath;
      var galleryButton = {
        label: (0, _QuizStrings.getString)('FROM_GALLERY'),
        callback: function () {
          var _callback = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
            var picture, imgSrc, dict;
            return _regenerator["default"].wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.prev = 0;
                    _context.next = 3;
                    return (0, _CordovaHelper.takePictureFromGallery)(500, 500);

                  case 3:
                    picture = _context.sent;

                    if (picture) {
                      imgSrc = "data:image/jpg;base64,".concat(picture);
                      dict = {};
                      dict[parentPath + '/value'] = imgSrc;
                      dict[parentPath + '/isEdited'] = true;
                      dict[parentPath + '/isDirty'] = _this.getForPath(parentPath + '/initial', '') !== imgSrc;

                      _GenericStore.dataStore.setValues(dict);
                    }

                    _context.next = 10;
                    break;

                  case 7:
                    _context.prev = 7;
                    _context.t0 = _context["catch"](0);
                    console.log('Error taking Picture from gallery in Component Runner', _context.t0);

                  case 10:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, null, [[0, 7]]);
          }));

          function callback() {
            return _callback.apply(this, arguments);
          }

          return callback;
        }()
      };
      var cameraButton = {
        label: (0, _QuizStrings.getString)('FROM_CAMERA'),
        callback: function () {
          var _callback2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
            var picture, imgSrc, dict;
            return _regenerator["default"].wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.prev = 0;
                    _context2.next = 3;
                    return (0, _CordovaHelper.takePictureWithCamera)(500, 500);

                  case 3:
                    picture = _context2.sent;

                    if (picture) {
                      imgSrc = "data:image/jpg;base64,".concat(picture);
                      dict = {};
                      dict[parentPath + '/value'] = imgSrc;
                      dict[parentPath + '/isEdited'] = true;
                      dict[parentPath + '/isDirty'] = _this.getForPath(parentPath + '/initial', '') !== imgSrc;

                      _GenericStore.dataStore.setValues(dict);
                    }

                    _context2.next = 10;
                    break;

                  case 7:
                    _context2.prev = 7;
                    _context2.t0 = _context2["catch"](0);
                    console.log('Error taking Picture with Camera in Component Runner', _context2.t0);

                  case 10:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2, null, [[0, 7]]);
          }));

          function callback() {
            return _callback2.apply(this, arguments);
          }

          return callback;
        }()
      };
      (0, _MuiAlertHelper.showAlertWithOptions)({
        html: (0, _QuizStrings.getString)('CHOOSE_IMAGE_SOURCE_TEXT'),
        title: (0, _QuizStrings.getString)('CHOOSE_IMAGE_SOURCE_TITLE'),
        centeredContent: true,
        buttons: [cameraButton, galleryButton]
      });
    });
    var _parentPath = _this.props.parentPath;

    _this.addStoresAndPathes([{
      store: _GenericStore.dataStore,
      pathes: [_parentPath]
    }]);

    var _dict = {};
    _dict[_parentPath + '/isValid'] = true;

    _GenericStore.dataStore.setValues(_dict);

    return _this;
  }

  (0, _createClass2["default"])(FormImage, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var parentPath = this.props.parentPath;
      var value = this.getForPath(parentPath + '/value', '');
      var isValid = this.getForPath(parentPath + '/isValid', true);
      var errorMessage = this.getForPath(parentPath + '/errorMessage', '');
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        style: style.picPreview
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: style.picPreviewContainer
      }, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
        style: style.previewPic,
        src: value || _ErgoCandidateView.DEFAULT_IMAGE
      })), /*#__PURE__*/_react["default"].createElement(StyledButton, {
        onClick: function onClick() {
          return _this2.changeProfilePic();
        }
      }, "Foto \xE4ndern")));
    }
  }]);
  return FormImage;
}(_StoreComponent2["default"]);

var _default = (0, _reactI18next.withTranslation)('common')(FormImage);

exports["default"] = _default;